import WorkspaceSelectionScreen from "../../components/workspace/WorkspaceSelectionScreen";

export default function SelectWorkspacePage() {
  return <WorkspaceSelectionScreen />;
}
